// extracted by mini-css-extract-plugin
export default {"contant":"PriceItimMoby_contant__hI+6E","delprice":"PriceItimMoby_delprice__Hul6l"};